import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { mapSessions, SessionMapping } from "../services/map-sessions";

export function useMapSessions() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (mappings: SessionMapping[]) => mapSessions(mappings),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["unmapped-sessions"] });
      toast({
        title: "Sessions mapped",
        description: `${data.mapped} session${data.mapped !== 1 ? "s" : ""} successfully linked to bundle.`,
      });
    },
    onError: () => {
      toast({
        title: "Mapping failed",
        description: "Failed to map sessions. Please try again.",
        variant: "destructive",
      });
    },
  });
}
